import type { GetRowIdFunc, GetRowIdParams } from "ag-grid-enterprise";

// AG Grid 35's SSRM LazyCache asks a null-data stub row for an id only to compare it; non-strings log warning #25.
const NO_ROW_ID = "";

const guardGetRowIdAgainstStubRows =
	<TData>(getRowId: (params: GetRowIdParams<TData>) => string): GetRowIdFunc<TData> =>
	(params) =>
		params.data == null ? NO_ROW_ID : getRowId(params);

export default guardGetRowIdAgainstStubRows;
